import React, { useState } from "react";
import * as XLSX from "xlsx-js-style";
import axios from "axios";
import Cookies from 'js-cookie';

const UploadDish = () => {
  const [loading, setLoading] = useState(false);

  // Reusable function to handle file uploads
  const handleFileUpload = async (file, endpoint = "/api/dish/upload2") => {
  if (!file) return;

  setLoading(true);
  try {
    const buffer = await file.arrayBuffer();
    const workbook = XLSX.read(buffer);
    // auto-detect the sheet that looks like the dish sheet from your screenshot
    let sheet = null;
    let sheetName = null;
    for (const name of workbook.SheetNames) {
      const rows = XLSX.utils.sheet_to_json(workbook.Sheets[name], { header: 1 });
      if (!rows || rows.length === 0) continue;
      // examine first non-empty row for header keywords
      const headerRow = rows[0].map(c => (c === null || c === undefined) ? '' : String(c).toLowerCase());
      const hasDish = headerRow.some(h => h.includes('dish'));
      const hasIng = headerRow.some(h => h.includes('ing') || h.includes('ingredient'));
      if (hasDish && hasIng) {
        sheet = workbook.Sheets[name];
        sheetName = name;
        break;
      }
    }
    // fallback to second sheet or first if detection fails
    if (!sheet) {
      sheetName = workbook.SheetNames[1] || workbook.SheetNames[0];
      sheet = workbook.Sheets[sheetName];
    }
    console.debug('Selected sheet for upload:', sheetName);

    // Get raw rows as array of arrays
    const allRows = XLSX.utils.sheet_to_json(sheet, { header: 1 });

    // Filter out empty arrays and null-only rows
    const cleanedRows = allRows.filter(row => {
      if (!Array.isArray(row)) return false;

      // Keep only rows that have at least one non-null/non-empty value
      return row.some(cell =>
        cell !== null &&
        cell !== undefined &&
        (typeof cell !== "string" || cell.trim() !== "")
      );
    });

    // Convert cleaned rows to pipe-delimited string for backend
    const excelText = convertExcelToJsonString(cleanedRows);

    // Don't send empty payloads — fail early with a helpful message
    if (!excelText || excelText.trim() === "") {
      console.warn("No data found on the selected sheet (empty or all blank rows).");
      alert("Upload failed: no data found in the selected sheet. Make sure the sheet contains rows.");
      setLoading(false);
      return;
    }

    // Send request to selected endpoint. Include credentials so server's JWT cookie is sent.
    const token = Cookies.get('accessToken');
    console.debug('Uploading to', endpoint, 'payload preview:', excelText.slice(0, 500));
    await axios.post(
      endpoint,
      { excelData: excelText },
      { withCredentials: true, headers: token ? { Authorization: `Bearer ${token}` } : {} }
    );

    alert("Upload successful!");
  } catch (err) {
    console.error("Error uploading file:", err);
    // surface backend message if available
    if (err.response && err.response.data) {
      console.error('Server response:', err.response.data);
      const serverMsg = err.response.data.message || JSON.stringify(err.response.data);
      alert(`Upload failed: ${serverMsg}`);
    } else {
      alert("Upload failed.");
    }
  } finally {
    setLoading(false);
  }
};

function convertExcelToJsonString(rows) {
  return rows.map(row =>
    row.map(cell => (cell !== null ? String(cell).trim() : "")).join("|")
  ).join("\n");
}

  return (
    <div className="p-4">
      {/* First Upload Section */}
      <h2 className="text-lg font-semibold mb-2">Upload Dish File</h2>
      <input
        type="file"
        accept=".xlsx, .xls"
        onChange={(e) => {
          if (e.target.files.length > 0) {
            handleFileUpload(e.target.files[0], "/api/dish/upload");
          }
        }}
        disabled={loading}
        className="border p-2 mr-2"
      />
      <button
        onClick={() => document.getElementById("fileInput1").click()}
        disabled={loading}
        className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded disabled:opacity-50"
      >
        {loading ? "Uploading..." : "Upload"}
      </button>

      {/* Hidden input for Upload 1 */}
      <input id="fileInput1" type="file" accept=".xlsx, .xls" hidden onChange={(e) => handleFileUpload(e.target.files[0], "/api/dish/upload")} />

      <hr className="my-6" />

      {/* Second Upload Section */}
      <h2 className="text-lg font-semibold mb-2">Upload 2</h2>
      <input
        id="fileInput2"
        type="file"
        accept=".xlsx, .xls"
        hidden
        onChange={(e) => handleFileUpload(e.target.files[0], "/api/dish/upload2")}
      />
      <button
        onClick={() => document.getElementById("fileInput2").click()}
        disabled={loading}
        className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded disabled:opacity-50"
      >
        {loading ? "Uploading..." : "Upload 2"}
      </button>

      {/* Optional Loader UI */}
      {loading && (
        <div className="mt-4 flex items-center space-x-2">
          <svg className="animate-spin h-5 w-5 text-blue-600" viewBox="0 0 24 24">
            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
            <path
              fill="currentColor"
              d="M4 12a8 8 0 018-8v4l3.5-3.5L12 0v4a8 8 0 018 8h-4l3.5 3.5L20 12h-4a8 8 0 01-8 8v-4l-3.5 3.5L4 20v-4a8 8 0 01-8-8h4z"
            />
          </svg>
          <span className="text-gray-600">Uploading...</span>
        </div>
      )}
    </div>
  );
};

export default UploadDish;